import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.79vw"
        },
        card: {
            width: "100%",
            height: "20.75vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "1.11vw"
        },
        card: {
            width: "100%",
            height: "7.11vw"            
        }
    }
};

export const PromoteAdLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="10" ry="10" width="21.65%" height="85%"/>
                        <rect x="33.43%" y="0%" rx="5" ry="5" width="63.76%" height="19.67%"/>
                        <rect x="33.43%" y="26.45%" rx="5" ry="5" width="51.12%" height="16.87%"/>
                        <rect x="33.43%" y="51.24%" rx="5" ry="5" width="32.32%" height="10.39%"/>
                        <rect x="67.43%" y="51.24%" rx="5" ry="5" width="32.32%" height="10.39%"/>
                        <rect x="33.43%" y="74.17%" rx="5" ry="5" width="39.64%" height="10.39%"/>
                    </> 
                    : <>
                        <rect x="1.75%" y="0%" rx="5" ry="5" width="9.97%" height="86.23%"/>
                        <rect x="13.55%" y="0%" rx="5" ry="5" width="54.37%" height="18.57%"/>
                        <rect x="79.55%" y="3.67%" rx="5" ry="5" width="17.77%" height="9.49%"/>
                        <rect x="13.55%" y="27.67%" rx="5" ry="5" width="43.48%" height="14.37%"/>
                        <rect x="13.55%" y="48.67%" rx="5" ry="5" width="28.96%" height="12.87%"/>
                        <rect x="45.62%" y="48.67%" rx="5" ry="5" width="28.96%" height="12.87%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}